import { useEffect } from 'react';
import { api } from '../services/api';
import { detectPlatform, isStandalone } from '../utils/in-app-browser';
import { isInstallReported, markInstallReported } from '../utils/pwa-installed';

/**
 * Girando DENTRO l'app installata, dirlo al server — una volta sola.
 *
 * È la sola cosa che chiude il buco di iOS. Lì il web app della schermata Home
 * ha uno storage separato da Safari, quindi la memoria locale
 * dell'installazione (utils/pwa-installed.ts) non raggiunge mai la scheda del
 * browser: senza questo, la card «Installa l'app» tornerebbe a proporsi ogni 30
 * giorni a chi l'app ce l'ha già, per sempre. L'account è l'unico canale che
 * attraversa quel confine, e qui l'utente è loggato perché è dentro l'app.
 *
 * Le tre condizioni non sono intercambiabili:
 *   · `isStandalone()` — è l'unico momento in cui l'installazione è un fatto
 *     osservato e non una deduzione;
 *   · sessione DAVVERO stabilita (`isAuthReady`), non il flag persistito: è la
 *     stessa guardia dell'idratazione delle preferenze, e senza si prende un
 *     401 al boot;
 *   · `isInstallReported()` — una POST per installazione, non una per avvio.
 *     Ripeterla sarebbe comunque innocua: la rotta è idempotente.
 */
export function useReportPwaInstall(
  isAuthReady: boolean,
  isAuthenticated: boolean,
  isGuest: boolean,
): void {
  useEffect(() => {
    if (!isAuthReady || !isAuthenticated || isGuest) return;
    if (!isStandalone() || isInstallReported()) return;

    // Spara e dimentica: se fallisce si riprova al prossimo avvio, e intanto non
    // c'è niente che l'utente debba vedere o fare.
    api.reportPwaInstalled(detectPlatform())
      .then(() => { markInstallReported(); })
      .catch(() => { /* rete assente o server giù: si riprova al prossimo avvio. */ });
  }, [isAuthReady, isAuthenticated, isGuest]);
}
